var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11400 3684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11399.334 -3682)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.585 8.021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.494,547.835H94.631a2.8,2.8,0,0,1-2.817-2.783v-5.387a.482.482,0,0,1,.964,0v5.387a1.844,1.844,0,0,0,1.853,1.831h7.864a1.844,1.844,0,0,0,1.853-1.831v-5.387a.482.482,0,0,1,.964,0v5.387A2.8,2.8,0,0,1,102.494,547.835Z",
    transform: "translate(-91.814 -539.189)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.275,514.431a.484.484,0,0,1-.325-.125l-8.526-7.683L81.9,514.306a.486.486,0,0,1-.681-.031.472.472,0,0,1,.031-.673l8.851-7.976a.486.486,0,0,1,.65,0L99.6,513.6a.472.472,0,0,1,.031.673A.484.484,0,0,1,99.275,514.431Z",
    transform: "translate(-81.09 -505.502)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.1303edb7ebeac9d0a501737b501d6165.svg";
export { ForwardRef as ReactComponent };